<div class="points-summary d-flex align-items-center justify-content-end text-end h-100 text-white">
  <div class="summary-point-value gloss-black">
    <span class="material-icons">loyalty</span>
    <span class="fw-bold">{{ pointsBalance$ | async | number : '1.0-0' }}</span>
  </div>
</div>
